import React from "react";

import IntroVideo from "../../assets/ChaloReviewIntro.mp4"

const HeroSection = () => {
    return (
<div className="relative w-full h-screen text-white flex" style={{ backgroundColor: '#f5f3ef',paddingBottom:"50px" }}>
    

{/* Video Background */}
<div className="relative w-full h-full ">
    <video
        autoPlay
        loop
        muted
        className="absolute top-0 left-0 w-full h-full object-contain " // Key change here
        style={{ marginTop:"50px" }}
         
    >
        <source src={IntroVideo} type="video/mp4" />
        Your browser does not support the video tag.
    </video>
</div>


</div>
    );
};

export default HeroSection;
